import {
    getCateringEventCategories,
    GetCateringEventCategoriesApiResponseSchema,
} from './get-catering-event-categories';
import {
    getPortfolioEventCardsByCategoryUid,
    GetPortfolioEventCardsByCategoryUidApiResponseSchema,
} from './get-portfolio-event-cards-by-category-uid';

export {
    GetPortfolioEventCardsByCategoryUidApiResponseSchema,
    GetCateringEventCategoriesApiResponseSchema,
};

export const PortfolioEventsPageActions = {
    getPortfolioEventCardsByCategoryUid,
    getCateringEventCategories,
};
